/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Cool_Quail_MarchInputs */

const en_pearl_cool_quail_march = /** @type {(inputs: Pearl_Cool_Quail_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create import`)
};

const de_pearl_cool_quail_march = /** @type {(inputs: Pearl_Cool_Quail_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import erstellen`)
};

/**
* | output |
* | --- |
* | "Create import" |
*
* @param {Pearl_Cool_Quail_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_cool_quail_march = /** @type {((inputs?: Pearl_Cool_Quail_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Cool_Quail_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_cool_quail_march(inputs)
	return de_pearl_cool_quail_march(inputs)
});